/** @file Orientation (twice the signed triangle area) of three points addressed by index in a flat array. */

/** (b − a) × (c − a) for points a, b, c of `p` = [x0, y0, x1, y1, …]; > 0 when a→b→c turns counter-clockwise (y-up). */
export function flatOrient(p: ArrayLike<number>, a: number, b: number, c: number): number {
  const ax = p[2 * a] ?? 0;
  const ay = p[2 * a + 1] ?? 0;
  return ((p[2 * b] ?? 0) - ax) * ((p[2 * c + 1] ?? 0) - ay) - ((p[2 * b + 1] ?? 0) - ay) * ((p[2 * c] ?? 0) - ax);
}
